//로그아웃 컴포넌트
function LogoutComponent(){
    return(
        <div className="LogoutComponent">
            <h1>Logout Success!</h1>
        </div>
    )
}

export default LogoutComponent